module.exports = __webpack_public_path__ + "img/questions.38a75ca8.svg";